import React from 'react';
import IndustryPageTemplate from '@/components/IndustryPageTemplate';
import { industryAds } from '@/config/ads';

const Fashion: React.FC = () => {
  return (
    <IndustryPageTemplate
      slug="fashion"
      industry="Fashion"
      heroHeadline="Create interactive ads to turn inspiration into action for fashion consumers."
      heroSubheadline="Bring collections to life with shoppable lookbooks, interactive galleries, and immersive brand experiences."
      section2Title="Fashion is driven by visuals, emotion, and personal expression."
      section2Content="Fashion advertising needs to inspire. Static banners can't capture the texture, movement, and emotion that drives purchase decisions. Interactive formats let consumers explore collections, see styling options, and connect with your brand story."
      section3Title="Interactive lookbooks and shoppable formats outperform static ads in engagement and conversion."
      section3Content="When shoppers can browse looks, zoom into details, and shop directly from the ad, they engage longer and convert at higher rates. Interactive fashion ads turn passive viewers into active shoppers."
      section4Title="Ideal for apparel brands, luxury labels, footwear, accessories, and fashion retailers."
      section4Content="Whether you're launching a new collection or driving seasonal sales, Adventive helps you create the immersive digital experiences today's fashion consumers expect."
      heroImage="https://d64gsuwffb70l.cloudfront.net/69408eb499b5789ef7367cf9_1765838649966_0eb2b025.png"
      heroAd={industryAds.fashion1}
      section2Ad={industryAds.fashion2}
      section3Ad={industryAds.fashion3}
      accentColor="bg-pink-100 text-pink-700"
      stats={[
        { value: '4x', label: 'Engagement rate' },
        { value: '+85%', label: 'Time on ad' },
        { value: '2.3x', label: 'Conversion lift' },
        { value: '60%', label: 'Lower CPA' },
      ]}
      benefits={[
        'Apparel and clothing brands',
        'Luxury fashion labels',
        'Footwear companies',
        'Fashion retailers and e-commerce',
      ]}
    />
  );
};

export default Fashion;
